export function convertDateTime(date){
    let dateString = date.toISOString().split('T')[0] + ' ' +
                    date.toISOString().split('T')[1].substr(0,8);
    return dateString;
}

export function addHours(date, hours) {
    date.setTime(date.getTime() + (hours*60*60*1000));
    return date;
}